export default "__VITE_ASSET__CbR0ZGLP__"